export interface Lot {
  id: string;
  nom: string;
  categorie: string;
  description?: string;
  unite: string;
  ordre: number; // Ordre d'exécution logique
}

export interface CategorieLot {
  id: string;
  nom: string;
  description: string;
  couleur: string;
  lots: Lot[];
}

export const CATEGORIES_LOTS: CategorieLot[] = [
  {
    id: 'preparation',
    nom: 'Préparation et Démolition',
    description: 'Travaux de préparation du chantier et démolition',
    couleur: 'red',
    lots: [
      {
        id: 'desamiantage',
        nom: 'Désamiantage Curage Déplombage',
        categorie: 'preparation',
        description: 'Travaux de désamiantage, curage et déplombage',
        unite: 'm²',
        ordre: 1
      },
      {
        id: 'demolition',
        nom: 'Démolition',
        categorie: 'preparation',
        description: 'Travaux de démolition',
        unite: 'm²',
        ordre: 2
      },
      {
        id: 'install-chantier',
        nom: 'Install Chantier - Gestion des déchets',
        categorie: 'preparation',
        description: 'Installation du chantier et gestion des déchets',
        unite: 'forfait',
        ordre: 3
      }
    ]
  },
  {
    id: 'structure',
    nom: 'Structure et Fondations',
    description: 'Travaux de structure et fondations',
    couleur: 'blue',
    lots: [
      {
        id: 'fondation',
        nom: 'Fondation',
        categorie: 'structure',
        description: 'Travaux de fondation',
        unite: 'm²',
        ordre: 4
      },
      {
        id: 'fondations-speciales',
        nom: 'Fondations spéciales',
        categorie: 'structure',
        description: 'Travaux de fondations spéciales',
        unite: 'm²',
        ordre: 5
      },
      {
        id: 'infrastructure',
        nom: 'Infrastructure',
        categorie: 'structure',
        description: 'Travaux d\'infrastructure',
        unite: 'm²',
        ordre: 6
      },
      {
        id: 'go-charpente',
        nom: 'GO y compris charpente hors infra',
        categorie: 'structure',
        description: 'Gros œuvre et charpente hors infrastructure',
        unite: 'm²',
        ordre: 7
      }
    ]
  },
  {
    id: 'enveloppe',
    nom: 'Enveloppe du Bâtiment',
    description: 'Travaux d\'enveloppe et de fermeture',
    couleur: 'green',
    lots: [
      {
        id: 'facades',
        nom: 'Façades',
        categorie: 'enveloppe',
        description: 'Travaux de façades',
        unite: 'm²',
        ordre: 8
      },
      {
        id: 'menuiseries-exterieures',
        nom: 'Menuiseries extérieures',
        categorie: 'enveloppe',
        description: 'Menuiseries extérieures',
        unite: 'm²',
        ordre: 9
      },
      {
        id: 'occultations',
        nom: 'Occultations',
        categorie: 'enveloppe',
        description: 'Travaux d\'occultation',
        unite: 'm²',
        ordre: 10
      },
      {
        id: 'couverture',
        nom: 'Couverture',
        categorie: 'enveloppe',
        description: 'Travaux de couverture',
        unite: 'm²',
        ordre: 11
      },
      {
        id: 'etancheite',
        nom: 'Étanchéité',
        categorie: 'enveloppe',
        description: 'Travaux d\'étanchéité',
        unite: 'm²',
        ordre: 12
      }
    ]
  },
  {
    id: 'technique',
    nom: 'Technique et Installations',
    description: 'Installations techniques et équipements',
    couleur: 'purple',
    lots: [
      {
        id: 'cfo-cfa',
        nom: 'CFO-CFA',
        categorie: 'technique',
        description: 'Installations électriques CFO-CFA',
        unite: 'm²',
        ordre: 13
      },
      {
        id: 'cvc',
        nom: 'CVC',
        categorie: 'technique',
        description: 'Chauffage, Ventilation, Climatisation',
        unite: 'm²',
        ordre: 14
      },
      {
        id: 'plomberie',
        nom: 'Plomberie',
        categorie: 'technique',
        description: 'Installations de plomberie',
        unite: 'm²',
        ordre: 15
      },
      {
        id: 'ascenseurs',
        nom: 'Ascenseurs',
        categorie: 'technique',
        description: 'Installation et équipement d\'ascenseurs',
        unite: 'forfait',
        ordre: 16
      }
    ]
  },
  {
    id: 'second-oeuvre',
    nom: 'Second Œuvre',
    description: 'Travaux de finition et aménagement',
    couleur: 'orange',
    lots: [
      {
        id: 'sols-souples',
        nom: 'Second œuvre : sols souples, sols durs',
        categorie: 'second-oeuvre',
        description: 'Travaux de sols souples et durs',
        unite: 'm²',
        ordre: 17
      },
      {
        id: 'faux-plafonds',
        nom: 'Second œuvre : faux plafonds',
        categorie: 'second-oeuvre',
        description: 'Installation de faux plafonds',
        unite: 'm²',
        ordre: 18
      },
      {
        id: 'faux-plancher',
        nom: 'Second œuvre : faux plancher',
        categorie: 'second-oeuvre',
        description: 'Installation de faux planchers',
        unite: 'm²',
        ordre: 19
      },
      {
        id: 'agencement',
        nom: 'Second œuvre : agencement, plâtrerie, cloisonnement',
        categorie: 'second-oeuvre',
        description: 'Travaux d\'agencement, plâtrerie et cloisonnement',
        unite: 'm²',
        ordre: 20
      },
      {
        id: 'menuiseries-interieures',
        nom: 'Menuiserie intérieures',
        categorie: 'second-oeuvre',
        description: 'Menuiseries intérieures',
        unite: 'm²',
        ordre: 21
      },
      {
        id: 'serrurerie',
        nom: 'Serrurerie métallurgie',
        categorie: 'second-oeuvre',
        description: 'Travaux de serrurerie et métallurgie',
        unite: 'm²',
        ordre: 22
      },
      {
        id: 'peinture',
        nom: 'Peinture',
        categorie: 'second-oeuvre',
        description: 'Travaux de peinture',
        unite: 'm²',
        ordre: 23
      }
    ]
  },
  {
    id: 'exterieur',
    nom: 'Extérieur et VRD',
    description: 'Travaux extérieurs et VRD',
    couleur: 'teal',
    lots: [
      {
        id: 'vrd',
        nom: 'VRD',
        categorie: 'exterieur',
        description: 'Voirie et Réseaux Divers',
        unite: 'm²',
        ordre: 24
      },
      {
        id: 'espaces-verts',
        nom: 'Espaces Verts',
        categorie: 'exterieur',
        description: 'Aménagement des espaces verts',
        unite: 'm²',
        ordre: 25
      }
    ]
  }
];

// Fonction utilitaire pour obtenir tous les lots
export const getAllLots = (): Lot[] => {
  return CATEGORIES_LOTS.flatMap(categorie => categorie.lots);
};

// Fonction utilitaire pour obtenir un lot par ID
export const getLotById = (id: string): Lot | undefined => {
  return getAllLots().find(lot => lot.id === id);
};

// Fonction utilitaire pour obtenir les lots d'une catégorie
export const getLotsByCategorie = (categorieId: string): Lot[] => {
  const categorie = CATEGORIES_LOTS.find(cat => cat.id === categorieId);
  return categorie ? categorie.lots : [];
};

// Fonction utilitaire pour obtenir une catégorie par ID
export const getCategorieById = (id: string): CategorieLot | undefined => {
  return CATEGORIES_LOTS.find(categorie => categorie.id === id);
};

// Fonction utilitaire pour obtenir la couleur d'une catégorie
export const getCategorieColor = (categorieId: string): string => {
  const categorie = getCategorieById(categorieId);
  return categorie ? categorie.couleur : 'gray';
};
